import { render, staticRenderFns } from "./OrderTabs.vue?vue&type=template&id=b09556c4&scoped=true&"
import script from "./OrderTabs.vue?vue&type=script&lang=js&"
export * from "./OrderTabs.vue?vue&type=script&lang=js&"
import style0 from "./OrderTabs.vue?vue&type=style&index=0&id=b09556c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09556c4",
  null
  
)

export default component.exports